// Easing curves for the reveal beat, by name (reveal.config.js picks them).
// Each maps t in [0, 1] to progress; t is clamped.
const c = t => (t < 0 ? 0 : t > 1 ? 1 : t)
export const EASING = {
    linear: t => c(t),
    quadIn: t => c(t) ** 2,
    quadOut: t => 1 - (1 - c(t)) ** 2,
    cubicIn: t => c(t) ** 3,
    cubicOut: t => 1 - (1 - c(t)) ** 3,
    cubicInOut: t => { t = c(t); return t < 0.5 ? 4 * t ** 3 : 1 - (-2 * t + 2) ** 3 / 2 },
    sineIn: t => 1 - Math.cos((Math.PI * c(t)) / 2),
    sineOut: t => Math.sin((Math.PI * c(t)) / 2),
    sineInOut: t => -(Math.cos(Math.PI * c(t)) - 1) / 2,
    expoOut: t => (c(t) === 1 ? 1 : 1 - 2 ** (-10 * c(t))),
    backOut: t => { t = c(t); const k = 1.70158; return 1 + (k + 1) * (t - 1) ** 3 + k * (t - 1) ** 2 },
}
export function ease(name) {
    const f = EASING[name]
    if (!f) throw new Error(`unknown easing "${name}" (one of ${Object.keys(EASING).join(', ')})`)
    return f
}
